import { Checkbox } from 'antd';
import styled from 'styled-components';
import { CredusText, color } from 'ui';
import { CheckboxChangeEvent } from 'antd/es/checkbox';

import { DeleteIcon } from '../../../../../assets/images/svgs';
import {
  TestDetails,
  TestQuestions,
} from '../../../../../contexts/TestContext';

interface TdProps {
  background?: string;
  gap?: string;
}

interface TestUploadTableProps {
  testData: TestDetails;
  setTestData: React.Dispatch<React.SetStateAction<TestDetails>>;
  selectedQuestions: string[];
  setSelectedQuestions: React.Dispatch<React.SetStateAction<string[]>>;
  showAnswers: boolean;
}

const TestUploadTable = ({
  testData,
  setTestData,
  selectedQuestions,
  setSelectedQuestions,
  showAnswers,
}: TestUploadTableProps) => {
  const handleCheckAll = () => {
    const testQuestions = testData.questions.map((el) => el.text);
    setSelectedQuestions((prev) =>
      prev.length == testQuestions.length ? [] : [...testQuestions]
    );
  };

  const handleCheck = (e: CheckboxChangeEvent) => {
    setSelectedQuestions((prev) =>
      selectedQuestions?.includes(e.target.value)
        ? [...prev.filter((text) => text !== e.target.value)]
        : [...prev, e.target.value]
    );
  };

  const handleDelete = (text: string) => {
    const questions = testData.questions.filter(
      (question) => question.text !== text
    );
    setTestData((prev) => ({ ...prev, questions }));
  };

  return (
    <>
      <Table>
        <tr>
          <Th>
            <Div>
              <Checkbox onChange={handleCheckAll} />
            </Div>
          </Th>
          <Th>
            <Div>
              {' '}
              <CredusText size="md">#</CredusText>
            </Div>
          </Th>
          <Th>
            <Div>
              <CredusText size="md">Question</CredusText>
            </Div>
          </Th>
          <Th>
            <Div>
              {' '}
              <CredusText size="md">Type</CredusText>
            </Div>
          </Th>
          <Th>
            <Div>
              <CredusText size="md">Points</CredusText>
            </Div>
          </Th>
          <Th>
            <Div>
              <CredusText size="md">Option 1</CredusText>
            </Div>
          </Th>
          <Th>
            <Div>
              <CredusText size="md">Option 2</CredusText>
            </Div>
          </Th>
          <Th>
            <Div>
              {' '}
              <CredusText size="md">Option 3</CredusText>
            </Div>
          </Th>
          <Th>
            <Div>
              <CredusText size="md">Action</CredusText>
            </Div>
          </Th>
        </tr>
        {testData.questions?.map((data: TestQuestions, index: number) => {
          const {
            text,
            type,
            point,
            option1Status,
            option2Status,
            option3Status,
          } = data;
          const optionBgColor = (status: null | string) =>
            data?.type == 'SA' ? '' : status ? '#0A8B38' : '#FDC453';
          const optionTextColor = (status: null | string) =>
            data?.type == 'SA'
              ? color.black
              : status
              ? color.white
              : color.black;
          return (
            <tr key={Math.random()}>
              <Td>
                <Div>
                  <Checkbox
                    checked={selectedQuestions.includes(text)}
                    value={text}
                    onChange={handleCheck}
                  />
                </Div>
              </Td>
              <Td>
                <Div>
                  <CredusText size="sm">Q{index + 1}</CredusText>
                </Div>
              </Td>
              <Td>
                <Div>
                  <CredusText size="sm">{text}</CredusText>
                </Div>
              </Td>
              <Td>
                <Div>
                  <CredusText size="sm">{type}</CredusText>
                </Div>
              </Td>
              <Td>
                <Div>
                  <CredusText size="sm">{point}</CredusText>
                </Div>
              </Td>
              <Td background={showAnswers ? optionBgColor(option1Status) : ''}>
                <Div>
                  <CredusText
                    size="sm"
                    color={showAnswers ? optionTextColor(option1Status) : ''}
                  >
                    {data?.option1 ?? '-'}
                  </CredusText>
                </Div>
              </Td>
              <Td background={showAnswers ? optionBgColor(option2Status) : ''}>
                <Div>
                  <CredusText
                    size="sm"
                    color={showAnswers ? optionTextColor(option2Status) : ''}
                  >
                    {data?.option2 ?? '-'}
                  </CredusText>
                </Div>
              </Td>
              <Td background={showAnswers ? optionBgColor(option3Status) : ''}>
                <Div>
                  <CredusText
                    size="sm"
                    color={showAnswers ? optionTextColor(option3Status) : ''}
                  >
                    {data?.option3 ?? '-'}
                  </CredusText>
                </Div>
              </Td>
              <Td background="#FFF6F4">
                <Div
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleDelete(text)}
                >
                  <DeleteIcon />
                  <CredusText size="sm" color={color.primary}>
                    Delete
                  </CredusText>
                </Div>
              </Td>
            </tr>
          );
        })}
      </Table>
    </>
  );
};

export default TestUploadTable;

const Table = styled.table`
  width: 100%;
`;

const Th = styled.th`
  background: #ffeae7;
  padding: 1rem;
  min-width: 44px;
`;
const Td = styled.td<TdProps>`
  background: ${({ background }) => (background ? background : ' #fbfbfb')};
  gap: ${(props) => props.gap};
  height: 58px;
  padding: 1rem 1.2rem;
  min-width: 44px;
`;

const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`;
